<template>
    <div class="oc-radio-group">
        <template v-if="layout === 'vertical'">
            <oc-row>
                <oc-col v-for="chunkNum in getChunksCount(optionsConverted)" :key="'col-' + chunkNum">
                    <template v-for="(option, key) in getChunk(optionsConverted, chunkNum)">
                        <div
                            :key="key"
                            class="custom-control custom-radio"
                        >
                            <oc-radio-input
                                :name="name"
                                :value="option.value"
                                :selected="selected"
                                :disabled="disabled || isDisabled(option)"
                                v-bind="option.inputAttrs"
                                v-on="$listeners"
                                :id="`oc-radio-group-${name}-${option.value}`"
                                class="custom-control-input"
                            />

                            <oc-label-input
                                :for="`oc-radio-group-${name}-${option.value}`"
                                v-bind="option.labelAttrs"
                                class="custom-control-label"
                            >
                                <slot name="label" v-bind="{option, selected, labelAttrs: option.labelAttrs}">
                                    {{option.text}}
                                </slot>
                            </oc-label-input>
                        </div>
                    </template>
                </oc-col>
            </oc-row>
        </template>
        <template v-else>
            <oc-row v-for="chunkNum in getChunksCount(optionsConverted)" :key="'row-' + chunkNum">
                <oc-col>
                    <div
                        v-for="(option, key) in getChunk(optionsConverted, chunkNum)"
                        :key="key"
                        class="custom-control custom-radio custom-control-inline"
                    >
                        <oc-radio-input
                            :name="name"
                            :value="option.value"
                            :selected="selected"
                            :disabled="disabled || isDisabled(option)"
                            v-bind="option.inputAttrs"
                            v-on="$listeners"
                            :id="`oc-radio-group-${name}-${option.value}`"
                            class="custom-control-input"
                        />

                        <oc-label-input
                            :for="`oc-radio-group-${name}-${option.value}`"
                            v-bind="option.labelAttrs"
                            class="custom-control-label"
                        >
                            <slot name="label" v-bind="{option, selected, labelAttrs: option.labelAttrs}">
                                {{option.text}}
                            </slot>
                        </oc-label-input>
                    </div>
                </oc-col>
            </oc-row>
        </template>
    </div>
</template>

<script>
import OptionsHandlerMixin from '@/components/form/base/helpers/OptionsHandlerMixin'
import ChunkMixin from '@/mixins/ChunkMixin'

export default {
    name: 'oc-radio-group-input',
    mixins: [OptionsHandlerMixin, ChunkMixin],
    props: {
        name: {
            type: [String, Number],
            required: true
        },
        selected: {
            type: [String, Number],
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        useTextAsValue: {
            type: Boolean,
            default: false
        },
        layout: {
            type: String,
            default: 'inline',
            validator: function (value) {
                return ['vertical', 'inline'].indexOf(value) !== -1
            }
        }
    },
    model: {
        prop: 'selected',
        event: 'input'
    },
    computed: {
        optionsConverted() {
            let options = OptionsHandlerMixin.computed.optionsConverted.call(this)

            let prepared = []

            options.forEach( (opt, index) => {
                if( opt.labelAttrs === undefined ) {
                    opt.labelAttrs = {}
                }

                if( opt.inputAttrs === undefined ) {
                    opt.inputAttrs = {}
                }

                if( this.useTextAsValue && (this.options[index] === undefined || this.options[index].value === undefined) ) {
                    opt.value = String(opt.text)
                }

                if( this.isVisible(opt) ) {
                    prepared.push(opt)
                }
            })

            return prepared
        }
    }
}
</script>
